import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LeadService} from '../../../shared/services/lead.service';
import {AlertService} from '../../../shared/services/alert.service';

@Component({
    selector: 'app-lead-detail',
    templateUrl: './lead-detail.component.html',
    styleUrls: ['./lead-detail.component.scss']
})
export class LeadDetailComponent implements OnInit {
    id: any;
    lead: any;
    loading: any = false;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private leadService: LeadService,
                private alertService: AlertService) {
    }

    ngOnInit(): void {
        this.id = this.activatedRoute.snapshot.params['id'];
        this.get();
    }

    get() {
        this.loading = true;
        this.leadService.detail(this.id).subscribe(data => {
            this.lead = data;
            this.loading = false;
        }, error => {
            this.loading = false;
        });
    }

    back() {
        this.router.navigate(['ask-expert-professional']);
    }
}
